var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUcla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.66 43.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-ucla-new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ucla-white"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.12,30.59A38.11,38.11,0,0,1,0,26.11L2.16,1.89h7.93L7.92,26.28c-.47,5.29,1.61,9.06,6.89,9.06s8.25-3.84,8.72-8.53l2.25-25h7.93l-2.2,24.68c-.88,9.49-7.18,16.6-17.36,16.6-7.94,0-13-5.13-14-12.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.52,22.34c1-11.63,8.88-21.27,22.43-21.27a18.59,18.59,0,0,1,10.41,3l-.9,9.61c-3.13-4.09-6.85-4.77-10.27-4.77-8.43,0-13.06,5.86-13.72,13.27-.63,7.22,3.14,13.09,11.26,13.09,3.57,0,7.35-1,11.31-5l-.88,9.86a22.76,22.76,0,0,1-11.05,3c-13.41,0-19.55-10-18.59-20.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.7,1.84h7.91L79.72,34.73H91c.8,0,3.5,0,4.23-.08,0,.4-.72,7.6-.72,7.6H71.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.9,16.93a9.69,9.69,0,0,0,.59-1.69h.12a9.43,9.43,0,0,0,.3,1.71c.43,1.84,3.51,12.07,3.51,12.07h-10s5.35-11.82,5.46-12.08m2-16.94h-.55L95.72,42.25h8.4l3-6.41h15.26l1.9,6.41h8.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUcla);
export default __webpack_public_path__ + "static/media/logo-ucla.1b2c5c26d31f5a94d3778bd9f87915dc.svg";
export { ForwardRef as ReactComponent };